import {Box} from '@mui/material'
import type {FC, ReactElement} from 'react'

type Props = {
  message: string | ReactElement
}

const DataGridError: FC<Props> = ({message}): ReactElement => (
  <Box
    height="100%"
    alignItems="center"
    justifyContent="center"
    data-testid="mbai-data-grid-error-box"
    sx={{display: 'flex'}}
  >
    <Box sx={{p: 2, textAlign: 'center'}}>{message}</Box>
  </Box>
)

export default DataGridError
